<h1 class="page-title mb-5"> انضم معنا </h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <p>انضم معنا</p>
                <p>تفعيلا لنص المادة 3 والمادة 126 من اللائحة التنفيذية لقانون الاستثمار التي تلزم الشركات بتقديم تقرير
                    سنوي للهيئة عن انشطتها في مجال المسئولية المجتمعية</p>
                <p>تقارير المسئولية المجتمعية</p>
                <p>شارك معنا بيانات المسئولية المجتمعية الخاصة بشركتك من خلال التسجيل عبر الرابط التالي:</p>
                <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSeZ4XvfWyDqA_wDuPH1GLAsIKXUGIsPUi14qeSHOruzKE6fJA/viewform">للتسجيل</a>
                <p>او شارك معنا تقارير المسئولية المجتمعية / الاستدامة الخاصة بالشركة، من خلال الارسال على الايميل
                    التالي:</p>
                <p>csr&#64;gafinet.org.eg</p>
            </div>
            <div class="col-md-3">
                <app-fix-how-we-can-help></app-fix-how-we-can-help>
            </div>
        </div>
    </div>
</div>